import React from 'react';

export const PointTable = ({ size = 18, ...rest }) => {
    return (
        <svg fill="#FEB45F" width="18" height="18" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 5v4h6V8H4zm0 6v4h6v-4H4zm8 0v4h6v-4h-6zm0-6v4h6V8h-6z" style={{ fill: "#FEB45F" }} />
        </svg>
    );
};
